import { SecondaryFilter } from "@/modules/Dashboards/AdminDashboard/models/SecondaryFilter";
import { TreeChildren } from "@/modules/Dashboards/AdminDashboard/models/TreeChilden";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { EVENT_EMITTER } from "../../constants/GenericSearchConstants";
import { ObjFilterList } from "../../model/List";

@Component({
  name: "FilterTypeShema"
})
export default class FilterTypeShema extends Vue {
  @Prop({ default: () => false }) isPrincipal!: boolean;
  @Prop() itemFilter!: SecondaryFilter;
  @Prop() private selectFilter!: ObjFilterList[];
  @Prop({ default: () => [] }) itemsSchema!: TreeChildren[];

  selection: TreeChildren[] = [];
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  clearData = 0;

  async beforeMount() {
    this.initFilter();
    await this.callData();
  }

  reload() {
    this.clearData = 1 - this.clearData;
  }

  callData() {
    this.$emit(EVENT_EMITTER.CALL_DATA, this.itemFilter);
  }

  get selectFilterLocal() {
    return this.selectFilter;
  }

  set selectFilterLocal(filterSelected: ObjFilterList[]) {
    this.$emit(EVENT_EMITTER.UPDATE_SELECT_FILTER, filterSelected);
  }

  getId(name: string) {
    return this.children?.findIndex(el => name === el.name) ?? -1;
  }

  get children() {
    return this.itemsSchema && this.itemsSchema.length > 0
      ? this.itemsSchema[0].children ?? []
      : [];
  }

  @Watch("children")
  @Watch("selectFilter")
  initFilter() {
    const selection: TreeChildren[] = [];
    const campos = this.children;
    if (campos.length == 0) {
      return;
    }
    campos.forEach(campoSelect => {
      const filterSelect = this.selectFilterLocal?.find(
        filterSelect => campoSelect.id == filterSelect.operation
      );

      if (!filterSelect) {
        return;
      }
      campoSelect.value = filterSelect.key;
      selection.push(campoSelect);
    });

    const compare =
      JSON.stringify(selection) === JSON.stringify(this.selection);
    if (!compare) {
      this.selection = selection;
    }
    this.reload();
  }

  @Watch("selection")
  updateSelection() {
    const selectFilter: ObjFilterList[] = [];
    this.selection.map(campo => {
      const campoSelect = campo.list?.find(
        filter => filter.value == campo.value
      );
      if (campoSelect) {
        selectFilter.push({
          key: campoSelect.value,
          name: campo.name + " = " + campoSelect.title,
          operation: campo.id
        });
      }
    });
    const compare =
      JSON.stringify(selectFilter) === JSON.stringify(this.selectFilterLocal);
    if (!compare) {
      this.selectFilterLocal = selectFilter;
    }
  }
}
